import { AppBreadcrumb, AppContainer, AppPagination } from '@/components/atoms';
import DeleteClinicTable from '@/components/molecules/DeleteClinicTable';
import type { DeleteClinic } from '@/types/admin-delete-clinic';
import type { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb';

interface AdminDeleteClinicListTemplateProps {
  data: DeleteClinic[];
  current: number;
  total: number;
  pageSize: number;
  loading?: boolean;
  breadcrumbItems: BreadcrumbItemType[];
  onPageChange: (page: number) => void;
  onRestoreClick: (record: DeleteClinic) => void;
  tenantNameBySiteType?: Map<string, string>;
  showSiteTypeColumn?: boolean;
}

const AdminDeleteClinicListTemplate = ({
  data,
  current,
  total,
  pageSize,
  loading,
  breadcrumbItems,
  onPageChange,
  onRestoreClick,
  tenantNameBySiteType,
  showSiteTypeColumn,
}: AdminDeleteClinicListTemplateProps) => {
  return (
    <AppContainer>
      <main className="space-y-5 px-4">
        <AppBreadcrumb items={breadcrumbItems} />
        <h3 className="text-xl">削除治療院</h3>

        <div className="bg-white rounded-md border">
          <DeleteClinicTable
            data={data}
            loading={loading}
            onRestoreClick={onRestoreClick}
            tenantNameBySiteType={tenantNameBySiteType}
            showSiteTypeColumn={showSiteTypeColumn}
          />
          <div className="flex justify-end p-4">
            <AppPagination
              current={current}
              total={total}
              pageSize={pageSize}
              onChange={onPageChange}
              hideOnSinglePage
            />
          </div>
        </div>
      </main>
    </AppContainer>
  );
};

export default AdminDeleteClinicListTemplate;
